export default "__VITE_ASSET__UpCsKrt___"